(function () {
  'use strict';

  class DecoratedVideoPlayerService {
    constructor(safetyService, $document, $rootScope, $window) {
      this.safetyService = safetyService;
      this.document = $document[0];
      this.window = $window;
      this.coachRequired = null;
      this.rootScope = $rootScope;
      this.addCloseListener();
      this.addCoachRequiredListener();
      this.addCommentListener();
    }

    addCommentListener() {
      this.window.addEventListener('commentSavedEvent', (event) => {
        if (event && event.detail) {
          const {vehicleId, datahora, comment} = event.detail;
          this.rootScope.$applyAsync(() => {
            this.rootScope.$emit('commentSavedEvent', {vehicleId, datahora, comment});
          });
        }
      });
    }

    addCoachRequiredListener() {
      this.window.addEventListener('coachRequiredEvent', (event) => {
        if (event && event.detail) {
          this.coachRequired = event.detail.coachRequired;
          this.rootScope.$applyAsync(() => {
            this.rootScope.$emit('coachRequiredUpdated', this.coachRequired);
          });
        }
      });
    }

    addCloseListener() {
      this.rootScope.$on('closeDecoratedVideoPlayer', () => {
        this.safetyService.unmountReactComponent('decoratedVideoPlayerModalContainer');
        this.rootScope.$emit('updateDecoratedVideoPlayer');
      });
    }

    loadDecoratedVideoPlayer(props, isSeparatedVideoScreen = false) {
      const componentId = 'decoratedVideoPlayerModalContainer';

      if (this.document.getElementById(componentId)) {
        this.safetyService.unmountReactComponent(componentId);
      }

      if (!isSeparatedVideoScreen) {
        props.onCloseDecoratedVideoPlayer = () => {
          this.rootScope.$apply(() => {
            this.rootScope.$emit('closeDecoratedVideoPlayer');
            if (typeof this.coachRequired === 'boolean') {
              this.rootScope.$emit('updateTable', {
                vehicleId: props.vehicleId,
                datahora: props.datahora,
                coachRequired: this.coachRequired
              });
            }
          });
        };
      }

      this.safetyService.loadReactComponent('safetyApp', './VideoPlayerModal', componentId, props)
        .catch(error => console.error('Error loading Decorated Video Player:', error));
    }
  }

  DecoratedVideoPlayerService.$inject = ['safetyService', '$document', '$rootScope', '$window'];

  angular
    .module('videoPlayer')
    .service('DecoratedVideoPlayerService', DecoratedVideoPlayerService);
})();
